import {API, FieldOptions, Notifications, Steps} from "../common/constants/constants";
import {GeneralDataInterface} from "../common/interfaces/GeneralDataInterface";
import {NotificationDataInterface} from "../common/interfaces/NotificationDataInterface";
import {ContactPersonDataInterface} from "../common/interfaces/ContactPersonDataInterface";
import {ApplicantDataInterface} from "../common/interfaces/ApplicantDataInterface";
import {createRequest, uploadFiles} from "../common/api/axxerion";
import {Buttons} from "../common/components/Buttons";
import {PopupInterface} from "../common/interfaces/PopupInterface";

interface Props {
    step: string
    files: File[],
    generalData: GeneralDataInterface,
    setGeneralData: (data: GeneralDataInterface) => void,
    applicantData: ApplicantDataInterface,
    contactPersonData: ContactPersonDataInterface,
    notificationData: NotificationDataInterface,
    setPopupData: (data: PopupInterface) => void,
    setLoading: (data: boolean) => void
    setStep: (data: string) => void
    confirmationUrl?: string
}

const ConfirmView = (props: Props) => {

    const {
        files,
        generalData,
        applicantData,
        contactPersonData,
        notificationData,
        setPopupData,
        setLoading,
        step,
        setGeneralData,
        setStep,
        confirmationUrl
    } = props

    if (step !== Steps.CONFIRM) {
        return null
    }

    const goToConfirmation = () => {
        if (confirmationUrl) {
            window.location.href = confirmationUrl
            return
        }

        setStep(Steps.CONFIRMED)
    }

    const submitData = async () => {

        if (files.length < 1) {
            setPopupData({
                message: Notifications.NO_PHOTO_FILE,
                title: 'Voeg een afbeelding toe',
                isActive: true
            })
            return
        }

        setLoading(true)

        try {
            const lowestProblemType = notificationData.defect?.Referentie || notificationData.part?.Referentie || notificationData.location?.Referentie || notificationData.environment?.Referentie || false
            const isActiveContactPerson = contactPersonData.isActive;

            const optionalFields = {
                ...(generalData.apiReference && {[FieldOptions.REF_VHE]: generalData.apiReference}),
                ...(lowestProblemType && {[FieldOptions.REF_PROBLEM_TYPE]: lowestProblemType}),
                ...(applicantData.company && {[FieldOptions.COMPANY]: applicantData.company}),
                ...(applicantData.name && {[FieldOptions.NAME]: applicantData.name}),
                ...(applicantData.email && {[FieldOptions.EMAIL]: applicantData.email}),
                ...(applicantData.phone && {[FieldOptions.PHONE]: applicantData.phone}),
                ...(isActiveContactPerson && contactPersonData.company && {[FieldOptions.COMPANY_ALTERNATIVE_CONTACT]: contactPersonData.company}),
                ...(isActiveContactPerson && contactPersonData.name && {[FieldOptions.NAME_ALTERNATIVE_CONTACT]: contactPersonData.name}),
                ...(isActiveContactPerson && contactPersonData.email && {[FieldOptions.EMAIL_ALTERNATIVE_CONTACT]: contactPersonData.email}),
                ...(isActiveContactPerson && contactPersonData.phone && {[FieldOptions.PHONE_ALTERNATIVE_CONTACT]: contactPersonData.phone}),
                ...(notificationData.description && {[FieldOptions.DESCRIPTION]: notificationData.description}),
            };

            const data = {
                [FieldOptions.EXTERNAL_SOURCE]: API.EXTERNAL_SOURCE_REFERENCE,
                ...optionalFields
            };

            const createRequestResponse = await createRequest(data)

            if (!createRequestResponse.id && createRequestResponse.errorMessage) {
                setPopupData({
                    message: Notifications.ERROR + createRequestResponse.errorMessage,
                    title: 'Error',
                    isActive: true
                })
                return
            }

            if (createRequestResponse.id) {
                setGeneralData({
                    ...generalData,
                    reportId: createRequestResponse.id
                })

                await uploadFiles(files, createRequestResponse.id)
                goToConfirmation()
            }
        } finally {
            setLoading(false)
        }

    }

    return (
        <>
            <Buttons
                hide={false}
                backButton={{
                    text: 'Terug',
                    onClick: () => setStep(Steps.REPORT_DATA),
                    disabled: false
                }}
                nextButton={{
                    text: 'Bevestig gegevens',
                    onClick: submitData,
                    disabled: false
                }}
            />
        </>

    )
}
export default ConfirmView
